import React from 'react'
import { BlurStyled } from './Blur.styles'

const Blur = () => {
  return (
    <BlurStyled />
  )
}

export default Blur